import { mixGray } from './coroaVip';

/**
 * O selo de fundador (techspec-correio §05): um medalhão 12×12 com duas fitas, bronze (Peregrino), prata (Cavaleiro) ou
 * ouro (Lorde). O mesmo desenho vai no nick do mundo (canvas), no chat, no perfil e na inspeção (SVG). As cores são as
 * da landing dos Founder Packs.
 */
export const METAL_DO_SELO: Readonly<Record<number, { base: string; claro: string; escuro: string }>> = {
  1: { base: '#c08a4a', claro: '#f0c48a', escuro: '#6b4317' },
  2: { base: '#c9d1dc', claro: '#ffffff', escuro: '#5d6672' },
  3: { base: '#e6c452', claro: '#fff2b0', escuro: '#7a5a10' }
};

/** As fitas (atrás do medalhão) e o medalhão, centrados em (0, 0). */
export const SELO_FITAS = 'M-3.6 1.8 -5.4 7.2 -3 6 -1.6 8 0 2.6zM3.6 1.8 5.4 7.2 3 6 1.6 8 0 2.6z';
export const SELO_ESTRELA = 'M0-3.1.8-1.1 3-1 1.3.3 1.9 2.4 0 1.2-1.9 2.4-1.3.3-3-1-.8-1.1z';

export const nivelDoSelo = (n: number | undefined | null): number => (n && n >= 1 && n <= 3 ? Math.trunc(n) : 0);

export function desenharSelo(g: CanvasRenderingContext2D, cx: number, cy: number, nivel: number, morto: boolean): void {
  const m = METAL_DO_SELO[nivelDoSelo(nivel)];
  if (!m) return;
  const cor = (c: string) => (morto ? mixGray(c, 0.5) : c);
  g.save();
  g.translate(cx, cy - 1);
  g.lineJoin = 'round';
  const fitas = new Path2D(SELO_FITAS);
  g.lineWidth = 2;
  g.strokeStyle = 'rgba(0,0,0,.85)';
  g.stroke(fitas);
  g.fillStyle = cor('#8a1f1a');
  g.fill(fitas);
  g.beginPath();
  g.arc(0, 0, 4.6, 0, Math.PI * 2);
  g.lineWidth = 2.4;
  g.stroke();
  const grad = g.createRadialGradient(-1.4, -1.6, 0.5, 0, 0, 4.8);
  grad.addColorStop(0, cor(m.claro));
  grad.addColorStop(0.55, cor(m.base));
  grad.addColorStop(1, cor(m.escuro));
  g.fillStyle = grad;
  g.fill();
  g.fillStyle = cor(m.escuro);
  g.fill(new Path2D(SELO_ESTRELA));
  g.restore();
}
